// removed by extract-text-webpack-plugin
module.exports = {"exercisesListItem":"tXXHRbbYrqIJQ6N_myVGq","exercisesListAddItem":"_2wYKxeFchzL72uWJ4qViYO","execisesListItemDifficulty":"_2vX2hm6ftAkTkP0UfSkYv8","exercisesListItemTitle":"_3EkT-ZoIRQ-AMoMfLXGug3","exercisesListItemCount":"_1gmbg4xLzsRxWUDyyL5QCq","dragHandle":"_2GdtBzn9ZjAKEhXw_rgRfB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExercisesListItem/ExercisesListItem.scss
// module id = 915
// module chunks = 0